import {AfterViewInit, Directive, ElementRef, HostListener, OnInit} from '@angular/core';

@Directive({
  selector: 'input[dynamic-date-input]'
})
export class DynamicDateInputDirective implements AfterViewInit {

  private element : ElementRef;

  constructor(element : ElementRef) {
    this.element = element;

  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      if(this.element.nativeElement.value){
        this.element.nativeElement.type = 'date';
      }
    })

  }



  @HostListener('focus')
  handleFocus()
  {
    this.element.nativeElement.type = 'date';
  }


  @HostListener('blur')
  handleBlur()
  {
    if(this.element.nativeElement.value == "")
    {
      this.element.nativeElement.type = 'text';
    }
  }

}
